export default function ($rootScope, $scope, $http, $q, $timeout, $stateParams, $state, $uibModal, $cookies, $uibModalInstance, CONFIG, Upload, ContentFulFactory, UtilitiesFactory, ngToast, isMultipleSelection, isNoUpload, image) {
    'ngInject';
    let utilities = UtilitiesFactory.getUtilities();
    let T = $scope.$root.T;

    $scope.setControlsToDirty = utilities.forms.setControlsToDirty;
    $scope.file = {};
    $scope.error = '';
    $scope.isProgress = false;
    $scope.isMultipleSelection = isMultipleSelection;
    $scope.isNoUpload = isNoUpload;
    $scope.image = image;
    $scope.isDone = false;
    console.log('image', image);


    /***
     * Check if it's adding or editing mode
     */
    if (!!image && !Array.isArray(image)) {
        $scope.file.title = image.fields.hasOwnProperty('title') ? image.fields.title.en : image.fields.file.en.fileName;
        $scope.file.description = image.fields.hasOwnProperty('description') ? image.fields.description.en : '';
        $scope.file.image = [];
        $scope.file.image.push({
            __url: image.fields.file.en.url
        })
    } else if (!!image && Array.isArray(image)) {
        $scope.file.title = image[0].fields.hasOwnProperty('title') ? image[0].fields.title.en : image[0].fields.file.en.fileName;
        $scope.file.description = image[0].fields.hasOwnProperty('description') ? image[0].fields.description.en : '';
        $scope.file.image = [];
        _.forEach(image, (img) => {
            $scope.file.image.push({
                sys: {
                    id: img.sys.id
                },
                __url: img.fields.file.en.url
            })
        });
    }

    /***
     * Upload Files
     * @param files
     */
    $scope.uploadFiles = (files) => {
        console.log(files);
        if (files.length > 0) {
            $scope.file.image = files;
        }
    };

    /***
     * Remove File
     * @param index
     */
    $scope.removeFile = (index) => {
        return $scope.file.image.splice(index, 1);
    };

    /***
     * Submit
     */
    $scope.submit = () => {
        $scope.isProgress = true;
        if (!$scope.isDone) {
            $scope.isDone = true;
            console.log(!!image, !Array.isArray(image), image);
            // single file
            if (!!image && !Array.isArray(image)) {
                let idFile = image.sys.id;
                ContentFulFactory.createAssetFromFiles()
                    .then((space) => space.getAsset(idFile)) // 2. Get 200
                    .then((asset) => { // 3. 304
                        console.log('asset promise 1 if: ');
                        console.dir(asset);
                        if (asset.fields.hasOwnProperty('title')) {
                            asset.fields.title['en'] = $scope.file.title;
                        } else {
                            asset.fields.file.en.fileName = $scope.file.title;
                        }

                        // update descriptions, etc
                        if (!!$scope.file.description) {
                            asset.fields.description = asset.fields.hasOwnProperty('description') ? asset.fields.description : {};
                            asset.fields.description['en'] = $scope.file.description;
                        }
                        //update the asset in contentful, expected 200
                        return asset.update()
                    })
                    // resolves the request on contentful: update
                    .then((asset) => {
                        console.log('asset promise 2 if: ');
                        console.dir(asset);
                        //save the asset, publish the asset
                        return asset.publish();
                    })
                    // publish successfiul, let's go on
                    .then((asset) => {
                        // show toast
                        console.log('asset promise 3 if: ');
                        console.dir(asset);
                        $timeout( () => {
                            $uibModalInstance.close();
                            ngToast.create({
                                className: 'toast-success',
                                content: `${$scope.file.title} ${T.HTTP_PUT_SUCCESS_NOTIFICATION}`,
                                timeout: 4000
                            });
                        }, 300)
                    })
                    .catch((e) => {
                        console.error(e);
                    })
            } else if (!!image && Array.isArray(image)) {
                // several files (array)
                let index = 0;
                _.forEach($scope.file.image, (image) => {
                    let idFile = image.sys.id;
                    ContentFulFactory.createAssetFromFiles()
                        .then((space) => space.getAsset(idFile))
                        .then((asset) => {
                            console.log('asset promise 1 else if: ');
                            console.dir(asset);
                            if (asset.fields.hasOwnProperty('title')) {
                                asset.fields.title['en'] = $scope.file.title;
                            } else {
                                asset.fields.file.en.fileName = $scope.file.title;
                            }

                            if (!!$scope.file.description) {
                                asset.fields.description = asset.fields.hasOwnProperty('description') ? asset.fields.description : {};
                                asset.fields.description['en'] = $scope.file.description;
                            }
                            return asset.update()
                        })
                        .then((asset) => {
                            return asset.publish();
                        })
                        .then((asset) => {
                            console.log('asset promise 2 else if: ');
                            console.dir(asset);
                            $timeout( () => {
                                index ++;
                                if (index === $scope.file.image.length) {
                                    $uibModalInstance.close();
                                    ngToast.create({
                                        className: 'toast-success',
                                        content: `${T.image} ${T.HTTP_PUT_SUCCESS_NOTIFICATION}`,
                                        timeout: 4000
                                    });
                                }
                            }, 300)
                        })
                        .catch((e) => {
                            console.error(e);
                        })
                });
            } else {
                // new file --> jpg, png, gif
                _.forEach($scope.file.image, (img) => {
                    Upload.upload({
                        url: `${CONFIG.customUploadUrl}upload`,
                        data: {file: img }
                    }).then( (data) => {
                        console.log('data:');
                        console.dir(data)

                        /**
                         * Create Asset
                         */
                        ContentFulFactory.createAssetFromFiles()
                            .then((space) => {
                                space.createAsset({
                                    fields: {
                                        title: {
                                            'en': $scope.file.title
                                        },
                                        description: {
                                            'en': $scope.file.description
                                        },
                                        file: {
                                            'en': {
                                                contentType: img.type,
                                                fileName: !!img.$ngfName ? img.$ngfName : img.name,
                                                upload: data.data.url
                                            }
                                        }
                                    }
                                })
                                    .then((asset) => {
                                        /**
                                         * Processing asset
                                         */
                                        console.log('processing asset...');
                                        console.log('asset promise 1 else: ');
                                        console.dir(asset);
                                        // probably here we have the issue with IE11
                                        let p1 = asset.processForLocale('en', {
                                            processingCheckWait: 500,
                                            processingCheckRetries: 10
                                        });

                                        p1.then((value) => {
                                            console.log('processing value...');
                                            console.log('asset promise 2 else: ');
                                            console.dir(asset);
                                        }).catch((e) => {
                                            console.error('Create Asset Error 1: ', error)
                                            $timeout( () => {
                                                $scope.requestInProgress = false;
                                                ngToast.create({
                                                    className: 'toast-danger',
                                                    content: `${T.HTTP_POST_ERROR_NOTIFICATION} ${img.$ngfName}`,
                                                    timeout: 6000
                                                });
                                                $scope.isProgress = false;
                                                $uibModalInstance.close();
                                            });
                                            $rootScope.raven.captureException(e);
                                            $rootScope.raven.showReportDialog();
                                        }).then((error) => {
                                            console.error('Create Asset Error 2: ', error)
                                        }, (e) => {
                                            $rootScope.raven.captureException(e);
                                            $rootScope.raven.showReportDialog();
                                        });

                                        return p1;
                                    })
                                    .then((asset) => {
                                        /**
                                         * Publishing asset
                                         */
                                        console.log('publishing asset...');
                                        console.log('asset promise 3 else: ');
                                        console.dir(asset);
                                        return asset.publish();
                                    })
                                    .then((asset) => {
                                        console.log('asset promise 4 else: ');
                                        console.dir(asset);
                                        $scope.isProgress = false;
                                        $uibModalInstance.close({asset});
                                        ngToast.create({
                                            className: 'toast-success',
                                            content: `${img.$ngfName} ${T.HTTP_POST_SUCCESS_NOTIFICATION}`,
                                            timeout: 6000
                                        });
                                    })
                                    .catch((error) => {
                                        console.error('Create Asset Error all: ', error)
                                        $rootScope.raven.captureException(error);
                                        $rootScope.raven.showReportDialog();
                                    })
                            });
                    }, (error) => {
                        $scope.error = error;
                    });
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/app.sidenav/addNewFilesCtrl.js